var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgListView = function SvgListView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M3.25 4.036a.43.43 0 0 0-.25.39c0 .109.1.268.21.334l.098.059h17.384l.095-.055a.45.45 0 0 0 .21-.306.42.42 0 0 0-.245-.422c-.078-.035-.407-.036-8.75-.036s-8.674.001-8.751.036m-.01 5.065a.41.41 0 0 0-.219.484c.033.116.164.25.273.28s17.305.03 17.415 0a.47.47 0 0 0 .273-.28.41.41 0 0 0-.22-.484l-.089-.045H3.33zm.045 5.035a.5.5 0 0 0-.266.277.42.42 0 0 0 .186.466l.083.055 8.694.005 8.693.005.089-.046c.262-.136.314-.455.107-.659a.45.45 0 0 0-.162-.104c-.102-.028-17.326-.027-17.424.001m.014 5.062a.7.7 0 0 0-.138.072.5.5 0 0 0-.16.306c-.001.163.101.322.25.388.077.035.407.036 8.75.036s8.673-.001 8.751-.036a.42.42 0 0 0 .245-.422.45.45 0 0 0-.21-.306l-.095-.055-8.66-.004c-7.044-.003-8.674 0-8.733.021",
    clipRule: "evenodd"
  })));
};
export default SvgListView;